module.exports = __webpack_public_path__ + "static/img/2.5ce5904.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/3/sp/2.png
// module id = P38+
// module chunks = 0